import { Button, Stack, TextField } from '@mui/material';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { verificationJson } from '../utils/verificationJson';
import { useState } from 'react';
export default function AttendanceDetailsVerification() {
  const [verification, setVerifiication] = useState({ id: '', value: '' });
  const [remarks, setRemarks] = useState('');

  const submitHandler = () => {
    if (verification?.id) console.log({ verification, remarks });
  };
  return (
    <Stack gap={2}>
      <GlobalSelectFieldWithoutFormikNew
        data={verificationJson}
        fullWidth={true}
        keys={{
          itemId: 'id',
          itemValue: 'label',
        }}
        label={'Verification Status'}
        selectedDetails={verification}
        setChange={setVerifiication}
      />
      <TextField multiline label="Remarks" rows={3} onChange={(e) => setRemarks(e.target.value)} value={remarks} />
      <Button
        variant="outlined"
        sx={{
          alignSelf: 'flex-end',
        }}
        onClick={submitHandler}
      >
        Submit
      </Button>
    </Stack>
  );
}
